export default {
    Draft: 0,
    Approved: 1,
    Live: 10
}